import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { format, parseISO } from "date-fns";
import $ from "jquery";
import { render } from "react-dom";
import { body } from "../FunctionsCore";
import { classCombinerFromPrefix } from "../RenderIdentifier";
import BuildInformationStyles from "./BuildInformationStyles.module.scss";
const styles = BuildInformationStyles;
const classCombiner = classCombinerFromPrefix("7dbbe7c144f59cb2");
const BuildInformationComponent = (props) => {
    const { gitJson } = props;
    // Do not alphabetize
    const stringsToDisplay = [
        //
        gitJson["git.branch"],
        //
        gitJson["git.commit.id.abbrev"],
        //
        gitJson["git.commit.message.short"],
        //
        format(parseISO(gitJson["git.commit.time"]), "PPp")
        //
    ];
    const lastIndex = stringsToDisplay.length - 1;
    return (_jsx("div", Object.assign({ className: cx(classCombiner(styles, "buildInformation")) }, { children: stringsToDisplay.map((st, nu) => _jsxs("span", { children: [st, nu === lastIndex
                    ? ""
                    : " | "] }, nu)) })));
};
const buildInformation = (buildInformationParameter) => {
    $(() => {
        const $div = $("<div></div>");
        $(body).append($div);
        render(_jsx(BuildInformationComponent, Object.assign({}, buildInformationParameter)), $div[0]);
    });
};
export { buildInformation };
